import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MenuGlyph = /*#__PURE__*/createElement("g", {
  id: "menu"
}, /*#__PURE__*/createElement("path", {
  d: "M29.8,21h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C31.3,21.7,30.6,21,29.8,21z"
}), /*#__PURE__*/createElement("path", {
  d: "M29.8,36.8h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C31.3,37.5,30.6,36.8,29.8,36.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M29.8,52.7h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C31.3,53.4,30.6,52.7,29.8,52.7z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.7,21h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C47.2,21.7,46.5,21,45.7,21z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.7,36.8h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C47.2,37.5,46.5,36.8,45.7,36.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.7,52.7h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C47.2,53.4,46.5,52.7,45.7,52.7z"
}), /*#__PURE__*/createElement("path", {
  d: "M61.5,21h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3C63,21.7,62.3,21,61.5,21z"
}), /*#__PURE__*/createElement("path", {
  d: "M61.5,36.8h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C63,37.5,62.3,36.8,61.5,36.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M61.5,52.7h-7.3c-0.8,0-1.5,0.7-1.5,1.5v7.3c0,0.8,0.7,1.5,1.5,1.5h7.3c0.8,0,1.5-0.7,1.5-1.5v-7.3 C63,53.4,62.3,52.7,61.5,52.7z"
}));
const Menu = createSvg({
  name: 'menu',
  path: MenuGlyph
});

export default Menu;
export { MenuGlyph };
